/**
 * Fancybox bindings for certificates and about photo gallery templates.
 *
 * @package LecardoVein
 */

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const GALLERY_ROOT_SELECTOR = '[data-certificates-gallery], [data-photo-gallery]';

/**
 * @param {Element} root
 * @return {void}
 */
function bindFancyboxGallery( root ) {
	Fancybox.bind( root, 'a[data-fancybox]', {
		Carousel: {
			infinite: true,
		},
	} );
}

/**
 * @return {void}
 */
function initFancyboxGalleries() {
	document.querySelectorAll( GALLERY_ROOT_SELECTOR ).forEach( bindFancyboxGallery );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initFancyboxGalleries );
} else {
	initFancyboxGalleries();
}
